<template>
  <div id="userMessage">
    <van-nav-bar :fixed="true" title="职位列表" left-arrow />
    <van-swipe :autoplay="3000" class="swipe">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
    <form action="/" class="search">
      <van-search
        v-model="searchStr"
        placeholder="全部"
        @cancel="onCancel"
        readonly
        clearable
        clickable
        @click="ShowPopub()"
        shape="round"
        :action-text="'搜索'"
        @search="onRefreshStart"
      />
    </form>

    <van-cell-group
      v-for="(item, i) in list"
      :key="i"
      class="item"
      @click="$router.push('/job/detail/' + item._id)"
    >
      <van-row>
        <van-col span="4">
          <van-image width="32" height="32" :src="logo" />
        </van-col>
        <van-col span="20">
          <div class="name">{{ item.name }}</div>
          <div class="info">{{ item.group }} | 本科及以上｜全国</div>
          <div class="date">
            {{ item._updatetime | parseTime("{y}-{m}-{d}") }}
          </div></van-col
        >
      </van-row>
    </van-cell-group>

    <van-popup v-model="showPopup" position="bottom">
      <form action="/" class="search">
        <van-picker
          title="岗位类别"
          show-toolbar
          :columns="jobClass"
          @confirm="onConfirm"
          @change="onChange"
        />
      </form>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "userMessage",
  props: {},
  components: {},
  data() {
    return {
      jobClass: [],
      showPopup: false,
      offset: 100,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,

      searchStr: "",
      title: "职位类别",
      useMessage: {},
      images: [
        require("@/assets/banner/banner1.png"),
        require("@/assets/banner/banner2.png"),
        require("@/assets/banner/banner3.png"),
      ],
      logo: require("@/assets/img/logo.jpg"),
    };
  },

  created() {
    this.listJobClass();
    this.getList();
  },
  methods: {
    listJobClass() {
      this.$request.jobclass().then((res) => {
        if (res.code == 0) {
          this.jobClass = res.data;
        }
      });
    },
    onConfirm(value, index) {
      this.showPopup = false;
      this.searchStr = value;
    },
    onChange(picker, value, index) {
      this.showPopup = false;
      this.searchStr = value;
      this.getList();
    },
    onCancel() {
      console.log("取消");
    },
    onCancel() {},
    onRefreshStart() {
      this.getList();
    },
    ShowPopub() {
      this.showPopup = true;
    },
    // 获取数据
    getList() {
      this.loading = true;
      let data = {
        paging: {
          limit: 10,
          page: this.pagenum,
        },
        req: {},
      };

      if (this.searchStr != "") {
        data.req.group = { $regex: this.searchStr };
      }
      console.log("wwww");
      this.$request
        .joblist(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          if (res.code == 0) {
            if (this.pagenum == 1) {
              this.list = res.data.items;
            } else {
              this.list = this.list.concat(res.data.items);
            }
            this.dataList = this.list;
            this.total = res.data.total;
            if (this.dataList.length >= this.total) {
              this.finished = true;
            }
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },

    onRefresh() {
      this.pagenum = 1;
      this.finished = false;

      this.getList();
      this.refreshing = false;
    },
    onLoad() {
      this.pagenum++;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
.item {
  // margin-top: 10px;
  padding: 15px;
}
.swipe {
  text-align: center;
  img {
    height: 200px;
  }
}
.name {
  font-size: 14px;
}
.date {
  font-size: 12px;

  color: lightgray;
}
.info {
  color: gray;
  font-size: 12px;
}
#userMessage {
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
}
#context {
  padding-top: 54px;
  padding-bottom: 64px;
}
</style>